import bus from './Bus'

export default {
    setRefreshToken(refreshToken) {
        bus.$emit('login');
        return window.localStorage.setItem('refreshToken', refreshToken);
    },
    setApiToken(apiToken) {
        return window.localStorage.setItem('apiToken', apiToken);
    },
    getRefreshToken() {
        return window.localStorage.getItem('refreshToken');
    },
    getApiToken() {
        return window.localStorage.getItem('apiToken');
    },
    resetTokens(){
        bus.$emit('logout');
        window.localStorage.removeItem('refreshToken');
        window.localStorage.removeItem('apiToken');
    }
};